export default {
  titulo: "Equipment",
  nuevo: "New equipment",
  nroSerie: "Serial number",
  infoAdicional: "Additional information",
  generar: "Generate",
  textProblema: "Describe the issue with the equipment",
  errorProblema: "Please enter the equipment issue",
  textAccesorios: "List the equipment accessories",
  precio: "Price",
  textNotasLegales: "(Appears in the order's legal notes)",
  nuevoTipo: "New equipment type",
  editarTipo: "Edit equipment type",
  tituloTipos: "Equipment types",
  eliminarTipo: "Delete equipment type",
  pregEliminarTipo: "Are you sure you want to delete the equipment type?",
  nuevaMarca: "New brand",
  editarMarca: "Edit brand",
  tituloMarcas: "Brands",
  eliminarMarca: "Delete brand",
  pregEliminarMarca: "Are you sure you want to delete the brand?",
  nuevoModelo: "New model",
  editarModelo: "Edit model",
  tituloModelos: "Models",
  eliminarModelo: "Delete model",
  pregEliminarModelo: "Are you sure you want to delete the model?",
  seleccionarEquipo: "Select equipment",
  busqueda: "Search by description, serial, type, brand or model",
  mostrarAsociados: "Show only equipment linked to the client",
  incluirInactivos: "Include inactive equipment",
  eliminar: "Delete equipment",
  pregEliminar: "Are you sure you want to delete the equipment: ",
  editar: "Edit equipment",
  imprimirCodBarras: "Print barcode",
  imprimirEtiqueta: "Print label",
  activo: "Active",
  fechaInstalacion: "Installation date",
  frecuenciaMant: "Maintenance frequency",
  dias: " (in days)",
  comodato: "Loaned",
  propiedad: "Company-owned",
  provCompra: "Purchase supplier",
  provServicio: "Technical service supplier",
  fechaCompra: "Purchase date",
  vidaUtil: "Useful life",
  años: " (in years)",
  valorResidual: "Residual value",
  errorValorResidual: "Must be less than the cost",
  depreciacion: "% Annual depreciation",
  nroInventario: "Inventory number",
  valorNeto: "Current net value",
  facturas: "Purchase invoices",
  historicoUbicacion: "Location history",
  asociarObra: "Associated work",
  obraOpcional: "The work is optional. The equipment's dispatches are recorded under this work.",
  empresa: "Company",
  ultMant: "Last maintenance",
  proxMant: "Next maintenance",
  ubicacion: "Equipment location",
  textUbicacion:
    "Browse through branches, departments and equipment of the account. When you select a branch, the associated departments will be shown. Then, by clicking on a department, you can see the related equipment. All this in a centralized and intuitive tree format.",
  sinUbicacion: "No location",
  buscarModelo: "Search by equipment type, brand or model",
  msgNotFound: "Equipment not found",

  checklists: {
    titulo: "Checklists",
    nuevo: "New checklist",
    eliminar: "Delete checklist",
    pregEliminar: "Are you sure you want to delete the checklist?",
    editar: "Edit checklist",
    nuevoItem: "New item",
    editarItem: "Edit item",
    eliminarItem: "Delete item",
    pregEliminarItem: "Are you sure you want to delete the item?",
    items: "Items"
  },

  planes: {
    titulo: "Maintenance plans",
    nuevo: "New maintenance plan",
    eliminar: "Delete maintenance plan",
    pregEliminar: "Are you sure you want to delete the maintenance plan?",
    editar: "Edit maintenance plan"
  }
}
